import { FormattedMessage } from "react-intl";

const EmailNotifications = () => {
    return (
        <div>
            <h2>
                <FormattedMessage
                    id="JiraSoftwarePricingPage.modalContents.emailNotifications.title"
                    defaultMessage="Email notifications"
                />
            </h2>
            <p>
                <FormattedMessage
                    id="JiraSoftwarePricingPage.modalContents.emailNotifications.body"
                    defaultMessage="Our Free plan for Jira lets you send a maximum of 100 email notifications each day. After 100 emails, your notifications will be paused until the following day. Upgrade to a paid plan to send unlimited email notifications."
                    description="Free is a product plan tier and should not be translated."
                />
            </p>
        </div>
    );
};

export default EmailNotifications;
